import QuickAddDialog from './QuickAddDialog';

export default QuickAddDialog;
